import { reactive } from 'vue'
import { AuthService } from '@/services/auth'
import { PaymentsService } from '@/services/payments'

export const authStore = reactive({
  user: AuthService.getUserData(),
  isAuthenticated: AuthService.isAuthenticated(),
  credits: 0,
  creditsLoading: false,
  appointmentMode: false,
  restaurantMode: false,
  customFlowMode: false,
  customFlowActiveId: null,
  subscriptionExpired: false,
  subscriptionChecked: false,
  subscriptionChecking: false,
  subscription: null, // Store full subscription data including plan_id
  sidebarCollapsed: localStorage.getItem('sidebar-collapsed') === 'true',

  setUser (userData) {
    this.user = userData
    this.isAuthenticated = true
  },

  clearUser () {
    this.user = null
    this.isAuthenticated = false
    this.credits = 0
    this.appointmentMode = false
    this.restaurantMode = false
    this.customFlowMode = false
    this.customFlowActiveId = null
    this.subscriptionExpired = false
    this.subscriptionChecked = false
    this.subscription = null
    AuthService.logout()
  },

  setAppointmentMode (isAppointmentMode) {
    this.appointmentMode = isAppointmentMode
  },

  setRestaurantMode (isRestaurantMode) {
    this.restaurantMode = isRestaurantMode
  },

  setCustomFlowMode (isEnabled, activeFlowId = null) {
    this.customFlowMode = isEnabled
    this.customFlowActiveId = activeFlowId
  },

  async login (credentials) {
    const response = await AuthService.login(credentials)
    AuthService.setAuthData(response)
    this.setUser(response.user)
    // Reset subscription cache for fresh check after login
    this.subscriptionExpired = false
    this.subscriptionChecked = false
    // Load credits after successful login
    this.loadCredits()
    return response
  },

  logout () {
    this.clearUser()
  },

  async loadCredits () {
    this.creditsLoading = true
    try {
      const creditsData = await AuthService.getUserCredits()
      this.credits = creditsData.credits || 0
    } catch (error) {
      console.error('Failed to load credits:', error)
      this.credits = 0
    } finally {
      this.creditsLoading = false
    }
  },

  async checkSubscription () {
    if (this.subscriptionChecking) return
    this.subscriptionChecking = true
    try {
      const result = await PaymentsService.getSubscriptionStatus()
      this.subscriptionExpired = result.success === false
      this.subscription = result.subscription || null
      this.subscriptionChecked = true
    } catch (error) {
      console.error('Failed to check subscription:', error)
    } finally {
      this.subscriptionChecking = false
    }
  },

  toggleSidebar () {
    this.sidebarCollapsed = !this.sidebarCollapsed
    localStorage.setItem('sidebar-collapsed', this.sidebarCollapsed)
    document.documentElement.style.setProperty(
      '--sidebar-width',
      this.sidebarCollapsed ? '64px' : '280px'
    )
  },

  // Check if user has access to WhatsApp Broadcast
  // Enterprise plans always have access; standard plans block IDs 4 (basic) and 5 (trial)
  canAccessBroadcast () {
    if (!this.subscription || !this.subscription.plan_id) return false
    if (this.subscription.is_enterprise) return true
    const planId = Number(this.subscription.plan_id)
    return planId !== 4 && planId !== 5
  }
})
